// Старый конструктор подбора Office (RequestController: request/pick и др.) — публичные страницы без входа
// (layout «check» + routeHead: App не проверяет авторизацию, как страницы экспедитора в operations.js).
// Адреса — те же, что в Office (/request/<действие>/<ключ>/<значение>/...?preset_id=...): на них ведут ссылки базы
// (rest.offline_read_remont / rest.read_draft_remont_list → constuctor_url приложения ОКК), LED (LED_PICK_URL),
// сайт и BI-редирект. Бэкенд: /office_port/constructor_pick/<действие>/ (office_api/office_port/areas/constructor_pick).
const page = (title, routeHead) => ({ layout: "check", routeHead, title });

export const pages = {};

export const routes = [
  {
    path: "/request/pick/:rest(.*)*",
    name: "officeCpPick",
    meta: page("Конструктор ремонта", "/request/pick"),
    component: () => import("@/views/office/constructor_pick/Pick.vue"),
  },
  {
    path: "/request/index/:rest(.*)*",
    name: "officeCpIndex",
    meta: page("Подбор ремонта", "/request/index"),
    component: () => import("@/views/office/constructor_pick/Landing.vue"),
  },
  {
    path: "/request/prices/:rest(.*)*",
    name: "officeCpPrices",
    meta: page("Выберите тариф", "/request/prices"),
    component: () => import("@/views/office/constructor_pick/Prices.vue"),
  },
  {
    path: "/request/child-presets/:rest(.*)*",
    name: "officeCpChildPresets",
    meta: page("Выберите тариф", "/request/child-presets"),
    props: { child: true },
    component: () => import("@/views/office/constructor_pick/Prices.vue"),
  },
  {
    path: "/request/planirovka-search/:rest(.*)*",
    name: "officeCpPlanirovkaSearch",
    meta: page("Найдите свою планировку", "/request/planirovka-search"),
    component: () => import("@/views/office/constructor_pick/PlanirovkaSearch.vue"),
  },
  {
    path: "/request/offer/:rest(.*)*",
    name: "officeCpOffer",
    meta: page("Публичная оферта", "/request/offer"),
    component: () => import("@/views/office/constructor_pick/Offer.vue"),
  },
];
